var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.vouchers'),"text":_vm.$t('vouchers.description'),"name":"vouchers","url":_vm.$listRoutes.vouchers,"table":_vm.vouchers,"filters":_vm.vouchersFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }